export default __webpack_public_path__ + "static/media/Danske-Regular.33a1979d.woff";